import { matchPath, Router } from 'react-router';
const FUNCTION = 'function';

const getDataRequests = (component = {}, dataEngine, state, datasource, fetchData) => {
    // fetchData is the normal param moving forward attached to routes explicitly, but
    // for backwards compatibility purposes will keep component as an option to pass in for legacy apps
    if (component.fetchData) {
        fetchData = component.fetchData;
    }
    if (fetchData) {
        const dataRequest = fetchData(state);

        if (typeof dataRequest.then === FUNCTION) {
            return dataRequest;
        } else if (typeof dataRequest === FUNCTION) {
            const req = dataEngine.dispatch(dataRequest);
            return Promise.resolve(
                    req
                );
        } else {
            return dataEngine.fetchAndStore(dataRequest.datasource || datasource, dataRequest.dataParams)
        }
    }
    return Promise.resolve();
};

const matchTree = (currentTree, branch, pathname) => {
    if (currentTree.path) {
        return matchPath(pathname, currentTree);
    } else if (branch.length) {
        return branch[branch.length - 1].match; // use parent match
    } else {
        return Router.computeRootMatch(pathname); // use default "root" match
    }
};

const treeScanner = (pathname, tree, dataEngine, state, branch = [], dataPromise = Promise.resolve()) => {
    let i = 0;
    let len = tree.length;
    const promises = [];

    for (; i < len; i++) {
        const currentTree = tree[i];
        const match = matchTree(currentTree, branch, pathname);

        if (match) {
            const { datasource, component, fetchData } = currentTree;

            const dataPromiseTree = dataPromise.then(() => {
                return getDataRequests(component, dataEngine, state, datasource, fetchData);
            });

            if (currentTree.routes) {
                promises.push(
                    treeScanner(pathname, currentTree.routes, dataEngine, state, branch, dataPromiseTree)
                );
            } else {
                promises.push(dataPromiseTree);
            }
        }
    };

    return promises.length ? Promise.allSettled(promises) : dataPromise;
};

export default treeScanner;
